__webpack_require__.p = "https://e-receipt.cloud/";